import { render } from "./product-gallery-3d.vue?vue&type=template&id=89596724"
import script from "./product-gallery-3d.vue?vue&type=script&lang=js"
export * from "./product-gallery-3d.vue?vue&type=script&lang=js"

import "./product-gallery-3d.vue?vue&type=style&index=0&id=89596724&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__